import React, {useState} from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import styles from '../styles/SalesPage.module.scss'
import { QuestionsItem } from '../components/QuestionsItem'
import cn from 'classnames'
import { ALL_META_TAG_QUERY } from '../apollo/query/all_meta_tag'
import { IMG_URL } from '../apollo/client-url'
import client from '../apollo/apollo-client'

export async function getServerSideProps (context) {
	const { data: allMetaTag, error } = await client.query({
		query: ALL_META_TAG_QUERY,
		variables: {
			where: {
				pageSlug: context.resolvedUrl
			},
		},
		fetchPolicy: 'no-cache'
	}).catch((error) => {
		console.log('errorerror', error)
		return error
	})
	
	return {
		props: {
			allMetaTag: allMetaTag?.allMetaTags || []
		}
	}
}

function ForeverFree (props) {
	const router = useRouter()

	const [showPricingMessage, setShowPricingMessage] = useState('')
	const [moreType, setMoreType] = useState('personalization')
	const [loyalty, setLoyalty] = useState('points')
	const [subscriptionType, setSubscriptionType] = useState('monthly')

	const isPersonalization = moreType === 'personalization'
	const isMarketing = moreType === 'marketing'
	const isSecurity = moreType === 'security'
	const isRelevant = moreType === 'relevant'

	const isPoints = loyalty === 'points'
	const isRewards = loyalty === 'rewards'
	const isTracking = loyalty === 'tracking'

	const isMonthly = subscriptionType === 'monthly'
	
	const metaTag = props.allMetaTag?.[0]
	
	return (
		<div className="static">
			<Head>
				<title>Forever Free - yesloyal</title>

				<meta charset="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1"/>
				<link rel="stylesheet" href="static/css/main.css" />

				<script src="static/js/main.js" defer></script>

				<link href="https://fonts.googleapis.com/css?family=Work+Sans:400,500,700&display=swap" rel="stylesheet"/>
				<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
				<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
				<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
				
				{metaTag?.title && <meta name="title" content={metaTag?.title} />}
				{metaTag?.title &&  <meta property="og:title" content={metaTag?.title} />}
				{metaTag?.title && <meta property="twitter:title" content={metaTag?.title} />}
				
				{metaTag?.description && <meta name="description" content={metaTag?.description} />}
				{metaTag?.description &&  <meta property="og:description" content={metaTag?.description} />}
				{metaTag?.description && <meta property="twitter:description" content={metaTag?.description} />}
				
				{metaTag?.ogType && <meta property="og:type" content={metaTag?.ogType} />}
				
				{metaTag?.twitterCard && <meta property="twitter:card" content={metaTag?.twitterCard} />}
				
				{metaTag?.imagePreview?.publicUrl && <meta property="og:image" content={`${IMG_URL}${metaTag.imagePreview.publicUrl}`} />}
			</Head>

			<header className={cn(styles.header)}>
				<div className={cn(styles.container, styles.header_item)}>
					<a href="/" className={styles.header_logo_link}>
						<img src="/logo.svg" alt="yesloyal" className={styles.header_logo}/>
					</a>

					<button className={cn(styles.blue_btn, styles.blue_btn_desktop)} onClick={() => router.push('/freesignup')}>
						Sign Up To Forever Free
					</button>
				</div>
			</header>

			<section className={styles.blue_bg}>
				<div className={cn(styles.container, styles.main, styles.main_desktop)}>
					<div className={styles.introduction}>
						<h1>
							Keep Customers <br/>
							Coming Back for Free.
						</h1>

						<p>
							yesloyal is built for 4-5 star rated Australian Small Businesses.
						</p>

						<p>
							It's a digital Smartphone solution to work alongside your physical stamp card program.
						</p>

						<p>
							We are offering a Forever Free Program to the first 50 businesses who sign up.
						</p>

						<div className={styles.introduction_actions}>
							<button
								className={styles.blue_btn}
								onClick={() => router.push('/freesignup')}
							>
								Sign Up To Forever Free
							</button>
							<button
								className={styles.link_btn}
								onClick={() => router.push('https://api.vadoo.tv/landing_page?vid=dQKgE4iFCQLr60vMk11iAiryr4Q2fVuF')}
							>
								Learn More
							</button>
						</div>
					</div>

					<div className={styles.introduction_image}>
						<img src="sales_page_iphones.png" alt="App Screens"/>
					</div>

				</div>

				<div className={cn(styles.container, styles.main, styles.main_mobile)}>
					<div className={styles.introduction}>
						<h1>
							Keep Customers <br/>
							Coming Back for Free.
						</h1>

						<div className={styles.main_mock_up}>
							<div className={styles.main_mock_up_text}>
								<p>
									yesloyal is built for 4-5 star rated Australian Small Businesses.
								</p>

								<p>
									It's a digital Smartphone solution to work alongside your physical stamp card program.
								</p>

								<p>
									We are offering a Forever Free Program to the first 50 businesses who sign up.
								</p>
							</div>

							<div className={cn(styles.introduction_image, styles.introduction_image_mobile)}>
								<img src="sales_page_iphones.png" alt="App Screens"/>
							</div>
						</div>

					</div>

					<div className={styles.introduction_actions}>
						<button
							className={styles.blue_btn}
							onClick={() => router.push('/freesignup')}
						>
							Sign Up To Forever Free
						</button>
						<button
							className={styles.link_btn}
							onClick={() => router.push('https://api.vadoo.tv/landing_page?vid=dQKgE4iFCQLr60vMk11iAiryr4Q2fVuF')}
						>
							Learn More
						</button>
					</div>

				</div>
			</section>

			<section className={cn(styles.white_bg, styles.more_wrapper)}>
				<div className={cn(styles.container, styles.margin)}>
					<div className={styles.physical}>
						<h2 className={styles.subtitle}>
							Honestly, Physical Stamp Cards <br/>
							Have Their Limitations!
						</h2>

						<p className={cn(styles.description, styles.description_stampcard)}>
							A physical stamp card is a great way to reward loyal <br/>
							customers, but digital can offer your business so	much more.
						</p>
					</div>

					<div className={cn(styles.more_container, styles.more_container_desktop)}>
						<div className={styles.more_img_wrapper}>
							<img className={cn(styles.more_img, isPersonalization ? styles.more_img_show : '')} src="/membership.png" alt="App example" />
							<img className={cn(styles.more_img, isMarketing ? styles.more_img_show : '')} src="/untitled-design-(23).png" alt="App example" />
							<img className={cn(styles.more_img, isSecurity ? styles.more_img_show : '')} src="/ebaystampcard.png" alt="App example" />
							<img className={cn(styles.more_img, isRelevant ? styles.more_img_show : '')} src="/untitled-design-(24).png" alt="App example" />
						</div>

						<div>

							<div className={cn(styles.more_description, isPersonalization ? styles.more_description_active : '')} onClick={() => setMoreType('personalization')}>
								<h3>
									<span className={styles.circle}/>More Personalization
								</h3>

								<p>
									yesloyal helps you to learn more about your customers and offer them a more personal service.
								</p>
							</div>

							<div className={cn(styles.more_description, isMarketing ? styles.more_description_active : '')} onClick={() => setMoreType('marketing')}>
								<h3>
									<span className={styles.circle}/>More Marketing Opportunities
								</h3>

								<p>
									yesloyal enables you access to SMS and email marketing services.
								</p>
							</div>

							<div className={cn(styles.more_description, isSecurity ? styles.more_description_active : '')} onClick={() => setMoreType('security')}>
								<h3>
									<span className={styles.circle}/>More Security, Nothing To Lose
								</h3>

								<p>
									yesloyal enables you protection from stamp/hole-punch scams that rob you of profit.
									You will also never need to replace lost cards because customers literally have nothing to lose.
								</p>
							</div>

							<div className={cn(styles.more_description, isRelevant ? styles.more_description_active : '')} onClick={() => setMoreType('relevant')}>
								<h3>
									<span className={styles.circle}/>More Relevant
								</h3>

								<p>
									yesloyal enables you a presence on each customer's Smartphone and helps you stand out to existing customers and also attract new customers.
								</p>
							</div>

						</div>

					</div>
				</div>
			</section>

			<section className={cn(styles.container, styles.business_section, styles.margin)}>
				<h3 className={cn(styles.subtitle, styles.subtitle_business)}>
					We Help Businesses Grow
				</h3>

				<div className={styles.business_list} >
					<div className={styles.business_item}>
						<div className={styles.business_item_logo}>
							<img src="/bague.png" alt="Business logo"/>
						</div>

						<div>
							<p>Full of passion and energized.</p>
							<p>We are so blessed to work with the yesloyal team.&nbsp;</p>
							<p>
								Very clear and professional when explaining everything we needed to know to join the loyalty program,
								nothing was hidden.&nbsp;
							</p>
							<p>The yesloyal team was so supportive, they answered and solved any issues quickly.&nbsp;</p>
							<p>
								Very passionate about helping small businesses and energised to share ideas and improvements every time
								we met.
							</p>
						</div>
						<div className={styles.business_owner}>
							OWNER OF BUN ME BAGUETTE
						</div>
					</div>

					<div className={styles.business_item}>
						<div className={styles.business_item_logo}>
							<img src="/mamatanglogo.png" alt="Business logo"/>
						</div>

						<div className={styles.business_description}>
							<p>Outstanding team and customer service!&nbsp;</p>
							<p>yesloyal app is very simple to use and has been an effective marketing tool for our business.&nbsp;</p>
							<p>
								Our customers are also enjoying the experience and rewards. What we appreciate the most is working with
								such an outstanding team with superb customer service! They have been very responsive and supportive
								throughout all communication. It has been a delight working with them!&nbsp;
							</p>
							<p>We definitely recommend yesloyal for your business!</p>
						</div>

						<div className={styles.business_owner}>
							OWNER OF MAMA TANG
						</div>
					</div>
				</div>

				<div className={styles.link} onClick={() => router.push('https://au.trustpilot.com/review/yesloyal.com')}>
					Read more Testimonials
					<span>
						<img src="/arrow_blue.svg" alt="Arrow"/>
					</span>
				</div>
			</section>

			<section className={cn(styles.white_bg, styles.loyalty_container)}>
				<div className={cn(styles.types, styles.container, styles.margin)}>
					<h3 className={styles.subtitle}>
						Simple, Powerful and Free
					</h3>

					<p className={styles.description}>
						The Merchant App lets you issue points via a free to download App for your business.
					</p>

					<p className={styles.description}>
						Your customers can access your loyalty program via the yesloyal App. Free to download.
					</p>

					<p className={styles.description}>
						You and your customer can now get all the benefits of digital
						without moving away from the Buy X Get 1 Free structure that you already have in place.
					</p>

					<div className={styles.types_list}>
						<div className={cn(styles.types_list_item, isPoints ? styles.types_list_item_active : '')} onClick={() => setLoyalty('points')}>
							<span className={styles.circle} />
							<span className={styles.types_list_item_name}>POINTS</span>
						</div>

						<div className={cn(styles.types_list_item, isRewards ? styles.types_list_item_active : '')} onClick={() => setLoyalty('rewards')}>
							<span className={styles.circle} />
							<span className={styles.types_list_item_name}>REWARDS</span>
						</div>

						<div className={cn(styles.types_list_item, isTracking ? styles.types_list_item_active : '')} onClick={() => setLoyalty('tracking')}>
							<span className={styles.circle} />
							<span className={styles.types_list_item_name}>TRACKING</span>
						</div>
					</div>
				</div>

				<div className={cn(styles.container, styles.margin, styles.container_mobile)}>
					<div className={cn(styles.loyalty_list, styles.loyalty_list_page_a, isPoints ? styles.loyalty_list_points_page_a : isRewards ? styles.loyalty_list_reward : '')}>
						<div className={cn(styles.loyalty_example_container, isPoints ? styles.loyalty_example_container_show : '')}>
							<div className={styles.loyalty_example_img}>
								<div className={styles.loyalty_example}>
									<div>
										<img src="/image-from-ios-(51).png" alt="Phone content"/>
									</div>

									<img src="/apple_iphone_11_pro_max_space_grey.png" alt="Phone"/>
								</div>
							</div>

							<div className={cn(styles.loyalty_example_content)}>
								<h3>
									Points instead of Stamps
								</h3>

								<div>
									<p className={styles.description}>
										On your digital program each stamp is converted to 50 points
										which you can issue via the Merchant App.
									</p>

									<p className={styles.description}>
										As an example, a Buy 6 Get 1 Free structure would mean
										the customer gets a free coffee after earning 300 points.
									</p>

									<p className={styles.description}>
										Every business is unique and our system will automatically
										calculate your points structure during the setup process to reflect
										your Buy X Get 1 Free structure.
									</p>
								</div>

								<div className={styles.loyalty_btn}>
									<button className={cn(styles.blue_btn, styles.blue_btn_margin)} onClick={() => router.push('/freesignup')}>
										Sign Up To Forever Free
									</button>
									<button className={styles.link_btn} onClick={() => router.push('https://api.vadoo.tv/landing_page?vid=dQKgE4iFCQLr60vMk11iAiryr4Q2fVuF')}>
										Learn more
									</button>
								</div>
							</div>
						</div>

						<div className={cn(styles.loyalty_example_container, isRewards ? styles.loyalty_example_container_show : '')}>
							<div className={styles.loyalty_example_img}>
								<div className={styles.loyalty_example}>
									<div>
										<img src="/image-from-ios-(48).png" alt="Phone content"/>
									</div>

									<img src="/apple_iphone_11_pro_max_space_grey.png" alt="Phone"/>
								</div>
							</div>

							<div className={styles.loyalty_example_content}>
								<h3>
									Rewards
								</h3>

								<div>
									<p className={styles.description}>
										Customers can easily see how far away they
										are from their next free reward.
									</p>

									<p className={styles.description}>
										Customers can earn and save up for multiple free rewards
										without having to hold onto multiple physical cards.
									</p>
								</div>

								<div className={cn(styles.loyalty_actions, styles.loyalty_btn)}>
									<button className={cn(styles.blue_btn, styles.blue_btn_margin)} onClick={() => router.push('/freesignup')}>
										Sign Up To Forever Free
									</button>
									<button className={styles.link_btn} onClick={() => router.push('https://api.vadoo.tv/landing_page?vid=dQKgE4iFCQLr60vMk11iAiryr4Q2fVuF')}>
										Learn more
									</button>
								</div>
							</div>
						</div>

						<div className={cn(styles.loyalty_example_container, isTracking ? styles.loyalty_example_container_show : '')}>
							<div className={styles.loyalty_example_img}>
								<div className={styles.loyalty_example}>
									<div>
										<img src="/image-from-ios-(58).png" alt="Phone content"/>
									</div>

									<img src="/apple_iphone_11_pro_max_space_grey.png" alt="Phone"/>
								</div>
							</div>

							<div className={styles.loyalty_example_content}>
								<h3>
									Happy Moments
								</h3>

								<div>
									<p className={styles.description}>
										Your customers will be able to see all the happy
										moments you've created for them in the activity
										section of the Customer App.
									</p>

									<p className={styles.description}>
										Happy moments?
									</p>

									<p className={styles.description}>
										Yes - the first day they joined your program,
										every time you awarded them points and the days
										they got given rewards.
									</p>
								</div>

								<div className={styles.loyalty_btn}>
									<button className={cn(styles.blue_btn, styles.blue_btn_margin)} onClick={() => router.push('/freesignup')}>
										Sign Up To Forever Free
									</button>
									<button className={styles.link_btn} onClick={() => router.push('https://api.vadoo.tv/landing_page?vid=dQKgE4iFCQLr60vMk11iAiryr4Q2fVuF')}>
										Learn more
									</button>
								</div>
							</div>
						</div>
					</div>

					<div className={styles.loyalty_btn_mobile}>
						<button className={cn(styles.blue_btn, styles.blue_btn_margin)} onClick={() => router.push('/freesignup')}>
							Sign Up To Forever Free
						</button>
						<button className={styles.link_btn} onClick={() => router.push('https://api.vadoo.tv/landing_page?vid=dQKgE4iFCQLr60vMk11iAiryr4Q2fVuF')}>
							Learn more
						</button>
					</div>
				</div>
			</section>

			<section className={cn(styles.container, styles.margin)}>
				<div className={cn(styles.free_sign_up, styles.margin)}>
					<h3 className={styles.subtitle}>
						It'll Take You 2 Minutes To Get Signed Up
					</h3>

					<p className={styles.description}>
						Setting up your Forever Free - Buy X Get
						1 Free program will be the easiest thing
						you've done all day.
					</p>

					<p className={styles.description}>
						Here are the steps involved.
					</p>
				</div>

				<div className={cn(styles.free_sign_up_step_list)}>
					<div className={styles.free_sign_up_step}>
						<div className={styles.free_sign_up_step_number}>1</div>
						<div className={cn(styles.free_sign_up_img, styles.free_sign_up_img_left)}>
							<img src="/how_your_program_works.png" alt="How your program works"/>
						</div>


						<div className={cn(styles.free_sign_up_content, styles.loyalty_example_content)}>
							<h3 className={styles.subtitle_small}>
								Configure Your Program
							</h3>

							<p className={styles.description}>
								Our system will automatically adjust your program
								to a points structure to reflect the Buy X
								Get 1 Free offer you want to give customers.
							</p>

							<p className={styles.description}>
								You can also decide if you want to
								offer some bonus points to entice customers to go digital.
							</p>

							<p className={styles.description}>
								These initial bonus points are called
								Welcome Points and are a great way to
								generate viral word of mouth for your business.
							</p>

							<div className={cn(styles.free_sign_up_img_mobile)}>
								<img src="/how_your_program_works.png" alt="How your program works"/>
							</div>

						</div>

					</div>

					<div className={styles.free_sign_up_step}>
						<div className={styles.free_sign_up_step_number}>2</div>
						<div className={cn(styles.free_sign_up_content, styles.free_sign_up_content_right, styles.loyalty_example_content)}>
							<h3 className={styles.subtitle_small}>
								Input Your Business Details
							</h3>

							<p className={styles.description}>
								Chances are Google Maps has a listing for your business already,
								if so we can speed up the sign up process by
								automatically grabbing your details from there.
							</p>

							<p className={styles.description}>
								If you aren't on Google, we can add you manually.
							</p>
						</div>

						<div className={cn(styles.free_sign_up_img, styles.free_sign_up_img_right)}>
							<img src="/map.png" alt="Map"/>
						</div>

						<div className={cn(styles.free_sign_up_img_mobile)}>
							<img src="/map_mobile.png" alt="Map"/>
						</div>
					</div>

					<div className={styles.free_sign_up_step}>
						<div className={styles.free_sign_up_step_number}>3</div>
						<div className={cn(styles.free_sign_up_img, styles.free_sign_up_img_left)}>
							<img src="/merchant_app.png" alt="Merchant App"/>
						</div>

						<div className={cn(styles.free_sign_up_content, styles.loyalty_example_content)}>
							<h3 className={styles.subtitle_small}>
								Download Your Merchant App
							</h3>

							<p className={styles.description}>
								The yesloyal Merchant App is free to download
								and puts the power of issuing points
								into the palm of your hands.
							</p>

							<p className={styles.description}>
								After we have received all your sign up
								information we will generate you a login and password.
							</p>

							<p className={styles.description}>
								You can then download and sign into the
								app to test that everything has been
								setup to your satisfaction.
							</p>

							<div className={cn(styles.free_sign_up_img_mobile)}>
								<img src="/merchant_app_mobile.png" alt="Merchant App"/>
							</div>
						</div>

					</div>

					<div className={styles.free_sign_up_step}>
						<div className={styles.free_sign_up_step_number}>4</div>
						<div className={cn(styles.free_sign_up_content, styles.free_sign_up_content_right)}>
							<h3 className={styles.subtitle_small}>
								Launch And Invite Customers To The yesloyal Customer App!
							</h3>

							<p className={styles.description}>
								Once you've decided to launch your
								program it's important to let your customers know.
							</p>

							<p className={cn(styles.description, styles.description_hilight)}>
								Point of Sale Poster
							</p>

							<p className={styles.description}>
								We wil email you a print-ready PDF poster.
							</p>

							<p className={cn(styles.description, styles.description_hilight)}>
								Online Link
							</p>

							<p className={styles.description}>
								We will email you a web invitation link
								so you can promote your program through
								your existing SMS, email and Social Media channels.
							</p>
						</div>

						<div className={cn(styles.free_sign_up_img, styles.free_sign_up_img_right)}>
							<img src="/qr_app.png" alt="Customer App Qr code"/>
						</div>

						<div className={cn(styles.free_sign_up_img_mobile)}>
							<img src="/qr_app.png" alt="Customer App Qr code"/>
						</div>
					</div>
				</div>
			</section>

			<section className={styles.white_bg}>
				<div className={cn(styles.container, styles.margin, styles.points)}>
					<h3 className={styles.subtitle}>
						OK, Points Replace Stamps, So How Do I Issue Points?
					</h3>
				</div>

				<div className={cn(styles.container_small, styles.margin)}>
					<div className={cn(styles.points_video)}>
						<div className={cn(styles.points_video_content)}>
							<h4 className={styles.description_hilight}>
								WATCH THIS VIDEO FOR MORE DETAILS
							</h4>

							<p className={styles.description}>
								The yesloyal Merchant App generates unique QR codes
								which allows your customers and members to collect
								loyalty points easily and securely.
							</p>

							<p className={styles.description}>
								We will provide you with a login and password.
							</p>

							<p className={styles.description}>
								All you'll need is a smartphone and internet connection.
							</p>
						</div>

						<iframe width="458" height="262" src="https://youtube.com/embed/eMRVzpI1feM"></iframe>
					</div>
				</div>
			</section>

			{/*<section>*/}
			{/*	<div className={cn(styles.container, styles.margin, styles.pricing_table)}>*/}
			{/*		<h3 className={styles.subtitle}>*/}
			{/*			Don't Miss Out! Be One Of The*/}
			{/*			First 50 To Sign Up Before This Offer Ends.*/}
			{/*		</h3>*/}

			{/*		<p className={styles.description}>*/}
			{/*			We have built a limited number of Forever Free plans*/}
			{/*			to help small businesses start their first digital*/}
			{/*			loyalty program without having to put in any money.*/}
			{/*		</p>*/}

			{/*		<p className={styles.description}>*/}
			{/*			The only criteria is that you are rated*/}
			{/*			by your customers on Google/facebook*/}
			{/*			as a 4-5 star business.*/}
			{/*		</p>*/}
			{/*	</div>*/}

			{/*	<div className={cn(styles.container, styles.margin)}>*/}
			{/*		<div className={styles.subscription_type}>*/}
			{/*			<button className={cn(isMonthly ? styles.blue_btn : styles.link_btn)} onClick={() => setSubscriptionType('monthly')}>*/}
			{/*				Monthly*/}
			{/*			</button>*/}
			{/*			<button className={cn(!isMonthly ? styles.blue_btn : styles.link_btn)} onClick={() => setSubscriptionType('yearly')}>*/}
			{/*				Yearly*/}
			{/*			</button>*/}

			{/*			<div className={cn(styles.subscription_discount, isMonthly ? styles.subscription_discount_hide : '')}>*/}
			{/*				<img src="/gift.svg" alt="Gift"/> <span>+20% discount</span>*/}
			{/*			</div>*/}
			{/*		</div>*/}
			{/*	</div>*/}

			{/*	<div className={cn(styles.container, styles.margin, styles.pricing_table_desktop)} style={{ overflow: 'auto' }}>*/}

			{/*		<div className={styles.pricing_table_container}>*/}
			{/*			<div className={styles.pricing_table_header}>*/}
			{/*				<div className={styles.desktop_pricing_item_name}>*/}
			{/*						Members*/}
			{/*						<img src="/cloud.svg" alt="Cloud"/>*/}

			{/*						<span>*/}
			{/*							Customers who have joined your program are known as members.*/}
			{/*						</span>*/}
			{/*				</div>*/}

			{/*				<div className={styles.desktop_pricing_item_name}>*/}
			{/*					<div>*/}
			{/*						Program Structure*/}

			{/*						<img src="/cloud.svg" alt="Cloud"/>*/}

			{/*						<span>*/}
			{/*							The Digital Stamp Card program is available on Forever Free.*/}
			{/*							Bronze and Silver plans allow you to select from additional program types.*/}
			{/*						</span>*/}
			{/*					</div>*/}
			{/*				</div>*/}


			{/*				<div className={styles.desktop_pricing_item_name}>*/}
			{/*					<div>*/}
			{/*						Merchant App*/}

			{/*						<img src="/cloud.svg" alt="Cloud"/>*/}

			{/*						<span >*/}
			{/*							A free to download app for your business to issue points and manage your program.*/}
			{/*						</span>*/}
			{/*					</div>*/}
			{/*				</div>*/}

			{/*				<div className={styles.desktop_pricing_item_name}>*/}
			{/*					<div>*/}
			{/*						Refer-a-friend feature*/}

			{/*						<img src="/cloud.svg" alt="Cloud"/>*/}

			{/*						<span >*/}
			{/*							Give your existing members the ability to*/}
			{/*							earn points for referring their friends and*/}
			{/*							family to your loyalty program.*/}
			{/*						</span>*/}
			{/*					</div>*/}
			{/*				</div>*/}

			{/*				<div className={styles.desktop_pricing_item_name}>*/}
			{/*					<div>*/}
			{/*						Website*/}

			{/*						<img src="/cloud.svg" alt="Cloud"/>*/}

			{/*						<span >*/}
			{/*							See mycoffeeshop.yesloyal.com for a sample of the website.*/}
			{/*						</span>*/}
			{/*					</div>*/}
			{/*				</div>*/}

			{/*				<div className={styles.desktop_pricing_item_name}>*/}
			{/*					<div>*/}
			{/*						Opt-in data export*/}

			{/*						<img src="/cloud.svg" alt="Cloud"/>*/}

			{/*						<span >*/}
			{/*							Ability to export member contact details of those who*/}
			{/*							have opted into direct communications from your business.*/}
			{/*						</span>*/}
			{/*					</div>*/}
			{/*				</div>*/}
			{/*			</div>*/}

			{/*			<div className={styles.pricing_table_blue} />*/}
			{/*			<div className={cn(styles.pricing_table_price)}>*/}
			{/*				<div className={cn(styles.pricing_table_price_item, styles.pricing_table_price_item_blue)}>*/}
			{/*					<div>*/}
			{/*						<div className={styles.price_item_header}>*/}
			{/*							Forever free*/}
			{/*						</div>*/}
			{/*						<div className={styles.price_item_description}>*/}
			{/*							Free. Nothing To Pay Ever!*/}
			{/*						</div>*/}
			{/*						<div className={styles.price_item_price}>*/}
			{/*							<span>$0</span>*/}
			{/*							Forever*/}
			{/*						</div>*/}
			{/*					</div>*/}

			{/*					<div className={styles.price_item_elements}>*/}
			{/*						<span className={styles.check} />*/}
			{/*						<div>*/}
			{/*							<span>Members</span>*/}
			{/*							Up to 500*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={styles.price_item_elements}>*/}
			{/*						<span className={styles.check} />*/}
			{/*						<div>*/}
			{/*							<span>Program Structure</span>*/}
			{/*							Digital Stamp Card*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={styles.price_item_elements}>*/}
			{/*						<span className={styles.check} />*/}
			{/*						<div>*/}
			{/*							<span>Merchant App</span>*/}
			{/*							1 x Login*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={cn(styles.price_item_elements, styles.price_item_elements_mobile)}>*/}
			{/*						<span className={styles.not_check} />*/}
			{/*						<div>*/}
			{/*							Refer-a-friend feature*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={cn(styles.price_item_elements, styles.price_item_elements_mobile)}>*/}
			{/*						<span className={styles.not_check} />*/}
			{/*						<div>*/}
			{/*							Websitе*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={cn(styles.price_item_elements, styles.price_item_elements_mobile)}>*/}
			{/*						<span className={styles.not_check} />*/}
			{/*						<div>*/}
			{/*							Opt-in data export*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*				</div>*/}

			{/*				<div className={styles.pricing_table_price_item} >*/}
			{/*					<div>*/}
			{/*						<div className={styles.price_item_header}>*/}
			{/*							BRONZE PLAN*/}
			{/*						</div>*/}
			{/*						<div className={styles.price_item_description}>*/}
			{/*							Increase Customers Spend*/}
			{/*						</div>*/}
			{/*						<div className={styles.price_item_price}>*/}
			{/*							<span>${isMonthly ? '68' : '45'}</span>*/}
			{/*							/month*/}
			{/*						</div>*/}
			{/*					</div>*/}

			{/*					<div className={styles.price_item_elements}>*/}
			{/*						<span className={styles.check_blue} />*/}
			{/*						<div>*/}
			{/*							<span>Members</span>*/}
			{/*							Up to 1000*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={styles.price_item_elements}>*/}
			{/*						<span className={styles.check_blue} />*/}
			{/*						<div>*/}
			{/*							<span>Program Structure</span>*/}
			{/*							Select a program*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={styles.price_item_elements}>*/}
			{/*						<span className={styles.check_blue} />*/}
			{/*						<div>*/}
			{/*							<span>Merchant App</span>*/}
			{/*							2 x Logins*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={cn(styles.price_item_elements, styles.price_item_elements_mobile)}>*/}
			{/*						<span className={styles.check_blue} />*/}
			{/*						<div>*/}
			{/*							Refer-a-friend feature*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={cn(styles.price_item_elements, styles.price_item_elements_mobile)}>*/}
			{/*						<span className={styles.check_blue} />*/}
			{/*						<div>*/}
			{/*							Websitе*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={cn(styles.price_item_elements, styles.price_item_elements_mobile)}>*/}
			{/*						<span className={styles.check_blue} />*/}
			{/*						<div>*/}
			{/*							Opt-in data export*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*				</div>*/}

			{/*				<div className={styles.pricing_table_price_item} >*/}
			{/*					<div>*/}
			{/*						<div className={styles.price_item_header}>*/}
			{/*							silver plan*/}
			{/*						</div>*/}
			{/*						<div className={styles.price_item_description}>*/}
			{/*							Grow Your Online Presence*/}
			{/*						</div>*/}
			{/*						<div className={styles.price_item_price}>*/}
			{/*							<span>${isMonthly ? '107' : '85'}</span>*/}
			{/*							/month*/}
			{/*						</div>*/}
			{/*					</div>*/}

			{/*					<div className={styles.price_item_elements}>*/}
			{/*						<span className={styles.check_blue} />*/}
			{/*						<div>*/}
			{/*							<span>Members</span>*/}
			{/*							Up to 2000*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={styles.price_item_elements}>*/}
			{/*						<span className={styles.check_blue} />*/}
			{/*						<div>*/}
			{/*							<span>Program Structure</span>*/}
			{/*							Select a program*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={styles.price_item_elements}>*/}
			{/*						<span className={styles.check_blue} />*/}
			{/*						<div>*/}
			{/*							<span>Merchant App</span>*/}
			{/*							3 x Logins*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={cn(styles.price_item_elements, styles.price_item_elements_mobile)}>*/}
			{/*						<span className={styles.check_blue} />*/}
			{/*						<div>*/}
			{/*							Refer-a-friend feature*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={cn(styles.price_item_elements, styles.price_item_elements_mobile)}>*/}
			{/*						<span className={styles.check_blue} />*/}
			{/*						<div>*/}
			{/*							Websitе*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*					<div className={cn(styles.price_item_elements, styles.price_item_elements_mobile)}>*/}
			{/*						<span className={styles.check_blue} />*/}
			{/*						<div>*/}
			{/*							Opt-in data export*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*				</div>*/}
			{/*			</div>*/}

			{/*		</div>*/}
			{/*	</div>*/}

			{/*	<div className={cn(styles.container, styles.margin, styles.pricing_table_mobile)} style={{ overflow: 'auto' }}>*/}

			{/*		<div className={styles.mobile_pricing_header}>*/}
			{/*			<div className={styles.mobile_pricing_header_blue}>Forever free</div>*/}
			{/*			<div className={styles.mobile_pricing_header_grey}>bronze plan</div>*/}
			{/*			<div className={styles.mobile_pricing_header_grey}>silver plan</div>*/}
			{/*		</div>*/}

			{/*		<div className={styles.mobile_pricing}>*/}

			{/*			<div className={styles.mobile_pricing_item}>*/}
			{/*				<div className={styles.blue_text}>*/}
			{/*					<span>$0</span> Forever*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					<span>${isMonthly ? '68' : '45'}</span> /month*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					<span>${isMonthly ? '107' : '85'}</span> /month*/}
			{/*				</div>*/}
			{/*			</div>*/}

			{/*			<div className={styles.mobile_pricing_item}>*/}
			{/*				<div className={styles.mobile_pricing_item_name}>*/}
			{/*					<div>*/}
			{/*						Members*/}

			{/*						<img src="/cloud.svg" alt="Cloud" onClick={() => setShowPricingMessage('members')}/>*/}
			{/*					</div>*/}
			{/*				</div>*/}

			{/*				<div className={styles.blue_text}>*/}
			{/*					Up to 500*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					Up to 1000*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					Up to 2000*/}
			{/*				</div>*/}
			{/*			</div>*/}

			{/*			{showPricingMessage === 'members' && (*/}
			{/*				<div className={styles.mobile_pricing_message}>*/}
			{/*					<span onClick={() => setShowPricingMessage('')} />*/}
			{/*					Customers who have joined your program are known as members.*/}
			{/*				</div>*/}
			{/*			)}*/}

			{/*			<div className={styles.mobile_pricing_item}>*/}
			{/*				<div className={styles.mobile_pricing_item_name}>*/}
			{/*					<div>*/}
			{/*						Program Structure*/}

			{/*						<img src="/cloud.svg" alt="Cloud" onClick={() => setShowPricingMessage('cloud_program')}/>*/}
			{/*					</div>*/}
			{/*				</div>*/}

			{/*				<div className={styles.blue_text}>*/}
			{/*					Digital*/}
			{/*					Stamp Card*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					Select a*/}
			{/*					program*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					Select a*/}
			{/*					program*/}
			{/*				</div>*/}
			{/*			</div>*/}

			{/*			{showPricingMessage === 'cloud_program' && (*/}
			{/*				<div className={styles.mobile_pricing_message}>*/}
			{/*					<span onClick={() => setShowPricingMessage('')} />*/}
			{/*					The Digital Stamp Card program is available on Forever Free.*/}
			{/*					Bronze and Silver plans allow you to select from additional program types.*/}
			{/*				</div>*/}
			{/*			)}*/}

			{/*			<div className={styles.mobile_pricing_item}>*/}
			{/*				<div className={styles.mobile_pricing_item_name}>*/}
			{/*					<div>*/}
			{/*						Merchant App*/}

			{/*						<img src="/cloud.svg" alt="Cloud" onClick={() => setShowPricingMessage('merchant_app')}/>*/}
			{/*					</div>*/}
			{/*				</div>*/}

			{/*				<div className={styles.blue_text}>*/}
			{/*					1 x Login*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					2 x Logins*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					3 x Logins*/}
			{/*				</div>*/}
			{/*			</div>*/}

			{/*			{showPricingMessage === 'merchant_app' && (*/}
			{/*				<div className={styles.mobile_pricing_message}>*/}
			{/*					<span onClick={() => setShowPricingMessage('')} />*/}
			{/*					A free to download app for your business to issue points and manage your program.*/}
			{/*				</div>*/}
			{/*			)}*/}

			{/*			<div className={styles.mobile_pricing_item}>*/}
			{/*				<div className={styles.mobile_pricing_item_name}>*/}
			{/*					<div>*/}
			{/*						Refer-a-friend feature*/}

			{/*						<img src="/cloud.svg" alt="Cloud" onClick={() => setShowPricingMessage('cloud_refer_a_friend')}/>*/}
			{/*					</div>*/}
			{/*				</div>*/}

			{/*				<div className={styles.blue_text}>*/}
			{/*					<span className={styles.not_check} />*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					<span className={styles.check_blue} />*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					<span className={styles.check_blue} />*/}
			{/*				</div>*/}
			{/*			</div>*/}

			{/*			{showPricingMessage === 'cloud_refer_a_friend' && (*/}
			{/*				<div className={styles.mobile_pricing_message}>*/}
			{/*					<span onClick={() => setShowPricingMessage('')} />*/}
			{/*					Give your existing members the ability to earn points for*/}
			{/*					referring their friends and family to your loyalty program.*/}
			{/*				</div>*/}
			{/*			)}*/}

			{/*			<div className={styles.mobile_pricing_item}>*/}
			{/*				<div className={styles.mobile_pricing_item_name}>*/}
			{/*					<div>*/}
			{/*						Website*/}

			{/*						<img src="/cloud.svg" alt="Cloud" onClick={() => setShowPricingMessage('website')}/>*/}
			{/*					</div>*/}
			{/*				</div>*/}

			{/*				<div>*/}
			{/*					<span className={styles.not_check} />*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					<span className={styles.check_blue} />*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					<span className={styles.check_blue} />*/}
			{/*				</div>*/}
			{/*			</div>*/}

			{/*			{showPricingMessage === 'website' && (*/}
			{/*				<div className={styles.mobile_pricing_message}>*/}
			{/*					<span onClick={() => setShowPricingMessage('')} />*/}
			{/*					See mycoffeeshop.yesloyal.com for a sample of the website.*/}
			{/*				</div>*/}
			{/*			)}*/}

			{/*			<div className={styles.mobile_pricing_item}>*/}
			{/*				<div className={styles.mobile_pricing_item_name}>*/}
			{/*					<div>*/}
			{/*						Opt-in data export*/}

			{/*						<img src="/cloud.svg" alt="Cloud" onClick={() => setShowPricingMessage('data_export')}/>*/}
			{/*					</div>*/}
			{/*				</div>*/}

			{/*				<div>*/}
			{/*					<span className={styles.not_check} />*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					<span className={styles.check_blue} />*/}
			{/*				</div>*/}
			{/*				<div>*/}
			{/*					<span className={styles.check_blue} />*/}
			{/*				</div>*/}
			{/*			</div>*/}

			{/*			{showPricingMessage === 'data_export' && (*/}
			{/*				<div className={styles.mobile_pricing_message}>*/}
			{/*					<span onClick={() => setShowPricingMessage('')} />*/}
			{/*					Ability to export member contact details of those*/}
			{/*					who have opted into direct communications from your business.*/}
			{/*				</div>*/}
			{/*			)}*/}

			{/*		</div>*/}
			{/*	</div>*/}
			{/*</section>*/}

			<section>
				<div className={cn(styles.container, styles.margin, styles.points, styles.points_padding)}>
					<h3 className={styles.subtitle}>
						Want A Demo?
					</h3>

					<p className={styles.description}>
						We've pre-recorded a demo video explaining
						the Forever Free Digital Stamp Program.
					</p>

					<p className={styles.description}>
						You can also speak to one of our
						team about the Forever Free Plan or any
						of our Paid plans by booking in a ZOOM demo.
					</p>

					<button className={styles.blue_btn} onClick={() => router.push('https://api.vadoo.tv/landing_page?vid=dQKgE4iFCQLr60vMk11iAiryr4Q2fVuF')}>
						Watch Pre-recorded Demo
					</button>

					<a href="https://yesloyal.com/chat" target='_blank' className={cn(styles.link, styles.link_margin)}>
						Book Live ZOOM Demo
						<span className="icon">
							<img src="/arrow_blue.svg" alt="Arrow"/>
						</span>
					</a>
				</div>
			</section>

			<section className={cn(styles.white_bg)}>
				<div className={cn(styles.container, styles.margin)}>
					<div className={cn(styles.margin, styles.paid_plans)}>
						<h3 className={styles.subtitle}>
							Want More Than A Buy X Get 1 Free Plan?
						</h3>

						<p className={styles.description}>
							We are happy to help.
						</p>

						<p className={styles.description}>
							We have helped many businesses with more advanced and cost effective programs plus marketing.
						</p>
					</div>

					<div className={styles.paid_plans_video}>
						<iframe width="450" height="300" src="https://youtube.com/embed/ZpSLxtPiHyM"></iframe>

						<iframe width="450" height="300" src="https://youtube.com/embed/Hxd2MCQPMwk"></iframe>
					</div>

					{/*<div style={{textAlign: 'center', marginBottom: '20px'}}>*/}
					{/*	<a href="https://yesloyal.com/pricing" target='_blank' className={cn(styles.link, styles.link_margin)}>*/}
					{/*		<span className={styles.link_hilight}>Paid plans</span>*/}
					{/*		See more*/}
					{/*		<span className="icon">*/}
					{/*		<img src="/arrow_blue.svg" alt="Arrow"/>*/}
					{/*	</span>*/}
					{/*	</a>*/}
					{/*</div>*/}
				</div>
			</section>

			{/*<section className={cn(styles.container, styles.margin)}>*/}
			{/*	<div className={cn(styles.margin, styles.sounds_great)}>*/}
			{/*		<h3 className={styles.subtitle}>*/}
			{/*			This Sounds Great, BUT I'm Closed Due To Covid Lockdowns.*/}
			{/*		</h3>*/}

			{/*		<p className={styles.description}>*/}
			{/*			We hear you. Here are our 2 recommendations.*/}
			{/*		</p>*/}

			{/*		<p className={styles.description}>*/}
			{/*			1. Lock in this offer and get everything*/}
			{/*			setup so you can take advantage of it when lockdowns lift.*/}
			{/*		</p>*/}

			{/*		<p className={styles.description}>*/}
			{/*			2. Consider using a yesloyal plan in conjunction*/}
			{/*			with our unique sticker solution for takeaways*/}
			{/*			and deliveries.*/}
			{/*		</p>*/}
			{/*	</div>*/}

			{/*	<div className={cn(styles.paid_plans_video)}>*/}
			{/*		<iframe width="525" height="300" src="https://youtube.com/embed/0qW4WC3uv18"></iframe>*/}

			{/*		<div>*/}
			{/*			<div className={styles.covid_description}>*/}
			{/*				<h4 className={styles.subtitle_very_small}>*/}
			{/*					FOR TAKEAWAYS*/}
			{/*				</h4>*/}

			{/*				<p className={styles.description}>*/}
			{/*					Invite people to your program using our sticker coupons*/}
			{/*					and give them points in a contactless way during COVID lockdowns.*/}
			{/*				</p>*/}
			{/*			</div>*/}

			{/*			<div className={styles.covid_description}>*/}
			{/*				<h4 className={styles.subtitle_very_small}>*/}
			{/*					FOR DELIVERIES*/}
			{/*				</h4>*/}

			{/*				<p className={styles.description}>*/}
			{/*					Invite UberEats (and other platform) customers to join*/}
			{/*					your program and communicate with them directly to save*/}
			{/*					yourself paying those high commissions.*/}
			{/*				</p>*/}
			{/*			</div>*/}

			{/*			<div className={styles.covid_actions}>*/}
			{/*				<button className={styles.blue_btn} onClick={() => router.push('/freesignup')}>*/}
			{/*					Sign Up To Forever Free*/}
			{/*				</button>*/}

			{/*				<a className={cn(styles.link_btn, styles.link_btn_how_much)} target='_blank' href='https://api.vadoo.tv/landing_page?vid=1jrIMQRRbF96rWuN2NBhmE3TljazREuB'>*/}
			{/*					How Much Are Coupons?*/}
			{/*				</a>*/}

			{/*			</div>*/}
			{/*		</div>*/}
			{/*	</div>*/}
			{/*</section>*/}

			<section className={cn(styles.white_bg, styles.questions)}>
				<div>
					<h3 className={styles.subtitle}>
						Frequently Asked Questions
					</h3>

					<div>
						<QuestionsItem
							title={'Who are yesloyal?'}
							description={
								<>
									<p>The team at yesloyal are focussed on helping small business owners grow.</p>
									<p>As an Australian based business we've made it our mission to help more small businesses to succeed.</p>
									<p>
										Together the management team have put decades of our experience and knowledge
										into the yesloyal platform and complimenting solutions.&nbsp;
									</p>
									<p>
										This helps a business grow faster through loyalty, customer
										acquisition, positive customer experiences and innovative technology.
									</p>
								</>
							}
						/>

						<QuestionsItem
							title={'What are the advantages of yesloyal?'}
							description={
								<>
									<p>#1 is we give you the option to start for free if you just want to digitise your current Buy X Get 1 Free program.</p>
									<p>We then give you very affordable no-contract paid programs that help you meet your key business objectives.</p>
									<p><strong>OUR DELIVERABLES TO SMALL BUSINESSES</strong></p>
									<p>We partner with you to create more happy customers which results in customers who:</p>
									<ul>
										<li>Buy more</li>
										<li>Buy more often</li>
										<li>Are engaged</li>
										<li>Increase word of mouth</li>
										<li>Bring family and friends to buy as well</li>
									</ul>
								</>
							}
						/>

						<QuestionsItem
							title={'Is your Forever Free plan really free?'}
							description={
								<>
									<p>
										Yes, 100% free. No setup cost. No hidden costs.
										No commissions. No Credit Card details required.
									</p>
								</>
							}
						/>
						<QuestionsItem
							title={"What's the difference between the Free plan and the Paid plans?"}
							description={
								<>
									<p>
										Our paid plan options are built for business owners who are in
										a position to invest more into the business to increase customer
										spend and their online presence through a no
										contracts paid engagement.&nbsp;
									</p>
									<p>
										See yesloyal.com/pricing for more details of the paid plans and what they offer.
									</p>
								</>
							}
						/>
						<QuestionsItem
							title={"Can I get a demo?"}
							description={
								<>
									<p>Yes, <a href="https://yesloyal.com/chat" target="_blank">click here </a>to book a demo.</p>
								</>
							}
						/>
					</div>
				</div>
			</section>

			<footer className={styles.white_bg}>
				<div className={cn(styles.margin, styles.container, styles.footer_top_link, styles.footer_top_link_desktop)}>
					<div className={cn(styles.footer_logo)}>
						<a href="/" target="_blank">
							<img alt="Logo" className="footer-04__logo"
							     src="/logo-small.png" height="20" />
						</a>
						<div>All rights reserved.</div>
					</div>

					<div className={styles.footer_link_wrapper}>
						<div>
							<h3>Business <br/> Resources</h3>
							<ul>
								<li>
									<a href="https://api.vadoo.tv/landing_page?vid=mH4XanGZC9h1sGmtPpgSMKjrGfUmcE2L" target="_blank">
										How to issue points
									</a>
								</li>
								<li>
									<a href="https://api.vadoo.tv/landing_page?vid=xQeK7GET7h6TegRKBV2kZmzqrg5Bhc4Q" target="_blank" >
										Delivery and Takeaways
									</a>
								</li>
								<li>
									<a href="https://business.yesloyal.com/" target="_blank">
										Refer Us
									</a>
								</li>
							</ul>
						</div>

						<div>
							<h3>Website</h3>
							<ul>
								<li>
									<a href="https://yesloyal.com" target="_blank">
										Visit our main website
									</a>
								</li>
								<li>
									<a href="https://yesloyal.com/blog" target="_blank">
										Our Blog
									</a>
								</li>
							</ul>
						</div>

						<div>
							<h3>About Us</h3>
							<ul>
								<li>
									<a href="www.facebook.com/yesloyal" target="_blank">
										Follow us on facebook
									</a>
								</li>
								<li>
									<a href="www.instagram.com/yesloyal" target="_blank">
										Check out our Instagram
									</a>
								</li>
							</ul>
						</div>
					</div>

					<div>
						<ul className={styles.footer_social}>
							<li>
								<a href="https://instagram.com/yesloyal" target="_blank">
									<img alt="instagram icon" src="/instagram.svg"/>
								</a>
							</li>
							<li>
								<a href="https://facebook.com/yesloyal" target="_blank">
									<img alt="facebook icon" src="/fb.svg"/>
								</a>
							</li>
						</ul>
					</div>

				</div>

				<div className={cn(styles.margin, styles.container, styles.footer_top_link, styles.footer_top_link_mobile)}>
					<div className={cn(styles.footer_logo)}>
						<a href="/" target="_blank">
							<img alt="Logo" className="footer-04__logo"
							     src="/logo-small.png" height="20" />
						</a>
						<div>All rights reserved.</div>
					</div>

					<div className={styles.footer_link_wrapper}>
						<div>
							<h3>Business <br/> Resources</h3>
							<ul>
								<li>
									<a href="https://api.vadoo.tv/landing_page?vid=mH4XanGZC9h1sGmtPpgSMKjrGfUmcE2L" target="_blank">
										How to issue points
									</a>
								</li>
								<li>
									<a href="https://api.vadoo.tv/landing_page?vid=xQeK7GET7h6TegRKBV2kZmzqrg5Bhc4Q" target="_blank" >
										Delivery and Takeaways
									</a>
								</li>
								<li>
									<a href="https://business.yesloyal.com/" target="_blank">
										Refer Us
									</a>
								</li>
							</ul>
						</div>

						<div>
							<h3>Website</h3>
							<ul>
								<li>
									<a href="https://yesloyal.com" target="_blank">
										Visit our main website
									</a>
								</li>
								<li>
									<a href="https://yesloyal.com/blog" target="_blank">
										Our Blog
									</a>
								</li>
							</ul>
						</div>

						<div>
							<h3>About Us</h3>
							<ul>
								<li>
									<a href="https://facebook.com/yesloyal" target="_blank">
										Follow us on facebook
									</a>
								</li>
								<li>
									<a href="https://instagram.com/yesloyal" target="_blank">
										Check out our Instagram
									</a>
								</li>
							</ul>
						</div>

						<div>
							<ul className={styles.footer_social}>
								<li>
									<a href="https://instagram.com/yesloyal" target="_blank">
										<img alt="instagram icon" src="/instagram.svg"/>
									</a>
								</li>
								<li>
									<a href="https://facebook.com/yesloyal" target="_blank">
										<img alt="facebook icon" src="/fb.svg"/>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div className={cn(styles.footer, styles.margin, styles.container)}>
					<ul className={cn(styles.footer_list)}>
						<li className="">
							<a target="_blank" href= "mailto:info@yesloyal.com" className={styles.footer_link} >
								Email us:
							</a>
						</li>

						<li className="">
							<a target="_blank" href="/app-privacy" className={styles.footer_link} >
								Privacy Policy
							</a>
						</li>

						<li className="">
							<a target="_blank" href="/yesloyal-business-terms" className={styles.footer_link} >
								Terms of Service
							</a>
						</li>
					</ul>
				</div>
			</footer>
		</div>
	)
}

export default ForeverFree
